import { Bar } from 'react-chartjs-2'
import React, { useState, useRef, useEffect } from 'react'

const BarChart = ({ chartData }) => {
  const [data, setData] = useState(chartData)
  const chartRef = useRef(null)
  useEffect(() => {
    setData(chartData)
    if (chartRef.current) {
      chartRef.current.reset()
    }
  }, [chartData])

  return (
    <div className="chart-container">
      <h2 style={{ textAlign: 'center', marginBottom: '0px' }}>Interview Analytics</h2>
      <Bar
        ref={chartRef}
        key={JSON.stringify(chartData)}
        redraw={false}
        data={data}
        options={{
          scales: {
            y: {
              max: 10,
              min: 0
            }
          },
          plugins: {
            title: {
              display: true
            },
            legend: {
              display: false
            }
          }
        }}
      />
    </div>
  )
}

export default BarChart
